// SWR hook for "recent orders from this customer". Backed by OrderApi.list
// with senderBusinessId filter — returns orders the customer (sender) has
// placed against the current supplier. Limited to a small page; the full
// list belongs in the dedicated purchase-sales screen.

import useSWR from "swr";
import { OrderApi } from "../../../apis";
import { IOrderPlus } from "../../../models/Order";

interface UseCustomerOrdersInput {
  senderBusinessId: string | null | undefined;
  limit?: number;
}

export const useCustomerOrders = ({ senderBusinessId, limit = 10 }: UseCustomerOrdersInput) => {
  const { data, isLoading, error, mutate } = useSWR(
    senderBusinessId ? ["customer-orders", senderBusinessId, limit] : null,
    async () => {
      const res = await OrderApi.list({
        // list-supplier-purchase.ts filters a PURCHASE list by `businessId` (= the sender) and
        // rejects unknown keys, so senderBusinessId / excel made this block a 400.
        filter: {
          type      : "PURCHASE",
          businessId: senderBusinessId as string,
        },
        offset: { limit, page: 1 },
      });
      return res;
    },
    { revalidateOnFocus: false },
  );

  return {
    orders : (data?.rows ?? []) as IOrderPlus[],
    total  : (data?.count ?? 0) as number,
    isLoading,
    error,
    refresh: mutate,
  };
};
